














import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import { institutionServer } from '@/api/installServer';

@Component({})
export default class RoleDeptChoice extends Vue {
  @Prop() private selectDeptIdList: Array<any> | [] | undefined;
  // 顶部部门列表
  deptTopList: Array<object> = [];
  deptIdList: any;
  deptTopChoose: any = {
    isIndeterminate: true,
    checkAll: false,
    checkedArr: this.deptIdList,
  };
  // 当前顶级部门id
  currentTopDeptId = '';
  created() {
    this.getTopDeptList();
    this.initDeptTopChooseCheckedArr();
  }

  /**
   * 获取顶级部门列表
   */
  getTopDeptList(): void {
    institutionServer
      .getAllTopDeptData({})
      .then((res: any) => {
        if (res && res.code === '200') {
          this.deptTopList = res.data;
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  /**
   * 全选
   * @param val 值
   */
  handleCheckAllChange(val: any): void {
    const deptIds: any = [this.currentTopDeptId];
    if (val) {
      this.deptTopList.forEach((item: any) => {
        deptIds.push(item.deptId);
      });
    }
    this.deptTopChoose.checkedArr = deptIds;
    this.deptTopChoose.isIndeterminate = false;
    this.$emit('deptIdList', deptIds);
  }

  /**
   * 对单个的选中
   * @param value
   */
  handleCheckedCitiesChange(value: any) {
    const checkedCount: number = value.length;
    this.deptTopChoose.checkAll = checkedCount === this.deptTopList.length;
    this.deptTopChoose.isIndeterminate = checkedCount > 0 && checkedCount < this.deptTopList.length;
    this.$emit('deptIdList', value);
  }

  /**
   * 初始化可见部门选择器的选中项
   */
  initDeptTopChooseCheckedArr() {
    const info: any = localStorage.getItem('userInfo');
    const userInfo: any = JSON.parse(info);
    this.currentTopDeptId = userInfo.topDeptId;
    this.deptTopChoose.checkedArr = [this.currentTopDeptId];
  }
}
